import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_target",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light" }, "Training Institute List")
  ])
], -1)
const _hoisted_3 = {
  id: "entity_target",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute Type", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Select District", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-2 mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = { class: "card mb-5 mb-xl-10" }
const _hoisted_25 = {
  id: "entity_target_list",
  class: "collapse show"
}
const _hoisted_26 = { class: "collapse show" }
const _hoisted_27 = { class: "card-body border-top p-0" }
const _hoisted_28 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_29 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_30 = { class: "row mt-1 w-100 m-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control ps-10 w-200px mt-1 form-control-sm",
      style: {"height":"1em"},
      placeholder: "Search"
    })
  ])
], -1)
const _hoisted_32 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_40 = { class: "collapse show" }
const _hoisted_41 = { class: "card-body border-top p-6" }
const _hoisted_42 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 1,
  class: "fw-bold d-block pt-1 mt-5"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-university fa-4x",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { key: 4 }
const _hoisted_53 = { class: "pt-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-slash text-light" }, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban text-light" }, null, -1)
const _hoisted_69 = [
  _hoisted_68
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_TrainningInstituteModal = _resolveComponent("TrainningInstituteModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    multiple: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_select, {
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    modelValue: _ctx.batch.association_info_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.association_info_id) = $event)),
                    style: {"width":"100%"},
                    multiple: "",
                    filterable: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterEntity(_ctx.batch.association_info_id)))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: data.id,
                          label: 
                      '[' + data.entity_short_name + '] - ' + data.entity_name
                    ,
                          value: data.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "association_info_id",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Type",
                    modelValue: _ctx.batch.institute_type_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.institute_type_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Empty",
                        value: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('Empty'))
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteTypes, (data) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: data.id,
                          label: data.name,
                          value: data.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "institute_info_id",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select District",
                    modelValue: _ctx.batch.district,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.district) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Empty",
                        value: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('Empty'))
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "institute_info_id",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select status",
                    modelValue: _ctx.batch.status,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.status) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Empty",
                        value: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('Empty'))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Active",
                        value: "1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Active")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Inactive",
                        value: "3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Inactive")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Pending",
                        value: "0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Pending")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Suspend",
                        value: "4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Suspend")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Reject",
                        value: "2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Reject")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "institute_info_id",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.institutionList())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_23
                  ])
                ])
              ]),
              (_ctx.showinstitutionList == true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: _ctx.componentKey,
                    class: "mt-3"
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _hoisted_31,
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                          title: "Download Xlse",
                                          "data-v-54b12dc8": "",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportTrainee()))
                                        }, _hoisted_34),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                          title: "Download PDF",
                                          "data-v-54b12dc8": "",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadPdf()))
                                        }, _hoisted_36),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                          title: "Print",
                                          "data-v-54b12dc8": "",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printPdf()))
                                        }, _hoisted_38)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createVNode(_component_Datatable, {
                                            "table-data": _ctx.instituteList,
                                            "table-header": _ctx.tableHeader,
                                            "enable-items-per-page-dropdown": true,
                                            total: _ctx.instituteList.length
                                          }, {
                                            "cell-index": _withCtx(({}) => [
                                              _createTextVNode(_toDisplayString(), 1)
                                            ]),
                                            "cell-logo": _withCtx(({ row }) => [
                                              (row.attach_file_info)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (
                                              row.attach_file_info.file_path
                                            )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          style: {"width":"80px"},
                                                          src: 
                                              _ctx.api_url +
                                              row?.attach_file_info?.file_path
                                            ,
                                                          alt: ""
                                                        }, null, 8, _hoisted_43))
                                                      : (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          style: {"width":"80px"},
                                                          src: 
                                              _ctx.api_url +
                                              '/storage/images/TrainingInstituteInfo/' +
                                              row?.attach_file_info
                                                ?.file_name_uploaded
                                            ,
                                                          alt: ""
                                                        }, null, 8, _hoisted_44))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47))
                                            ]),
                                            "cell-uniqueId": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.training_institute_no), 1)
                                            ]),
                                            "cell-short_name": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.short_name), 1)
                                            ]),
                                            "cell-full_name": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.institute_name), 1)
                                            ]),
                                            "cell-phone": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.telephone), 1)
                                            ]),
                                            "cell-email": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.email), 1)
                                            ]),
                                            "cell-website": _withCtx(({ row }) => [
                                              _createTextVNode(_toDisplayString(row.web_url), 1)
                                            ]),
                                            "cell-status": _withCtx(({ row }) => [
                                              (row.active_status == 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString('Pending')))
                                                : _createCommentVNode("", true),
                                              (row.active_status == 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString('Active')))
                                                : _createCommentVNode("", true),
                                              (row.active_status == 3)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString('Inactive')))
                                                : _createCommentVNode("", true),
                                              (row.active_status == 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString('Reject')))
                                                : _createCommentVNode("", true),
                                              (row.active_status == 4)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString('Suspend')))
                                                : _createCommentVNode("", true)
                                            ]),
                                            "cell-actions": _withCtx(({ row: institute }) => [
                                              _createElementVNode("div", _hoisted_53, [
                                                _createVNode(_component_router_link, {
                                                  title: "View",
                                                  class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                  to: {
                                              name: 'institute view',
                                              params: { id: institute.id },
                                            }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_54
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]),
                                                (_ctx.actionEdit)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      title: "Edit",
                                                      "data-kt-drawer-toggle": "true",
                                                      "data-kt-drawer-target": "#kt_drawer_training_institute",
                                                      onClick: ($event: any) => (_ctx.edit(institute)),
                                                      id: "kt_drawer_training_institute_button",
                                                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                                    }, _hoisted_57, 8, _hoisted_55))
                                                  : _createCommentVNode("", true),
                                                (_ctx.actionDelete)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      title: "Delete",
                                                      onClick: ($event: any) => (_ctx.Delete(institute.id)),
                                                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1"
                                                    }, _hoisted_60, 8, _hoisted_58))
                                                  : _createCommentVNode("", true),
                                                (_ctx.adminCheck)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 2,
                                                      onClick: ($event: any) => (_ctx.Suspend(institute.id)),
                                                      title: "Suspend",
                                                      class: "btn btn-icon btn-bg-warning btn-active-color-primary btn-sm me-1"
                                                    }, _hoisted_63, 8, _hoisted_61))
                                                  : _createCommentVNode("", true),
                                                (
                                              _ctx.adminCheck &&
                                              institute.active_status !== 1
                                            )
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 3,
                                                      onClick: ($event: any) => (_ctx.Active(institute.id)),
                                                      title: "Active",
                                                      class: "btn btn-icon btn-bg-warning btn-active-color-primary btn-sm me-1"
                                                    }, _hoisted_66, 8, _hoisted_64))
                                                  : _createCommentVNode("", true),
                                                (
                                              _ctx.adminCheck &&
                                              institute.active_status !== 3
                                            )
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 4,
                                                      onClick: ($event: any) => (_ctx.Inactive(institute.id)),
                                                      title: "Inactive",
                                                      class: "btn btn-icon btn-bg-warning btn-active-color-primary btn-sm"
                                                    }, _hoisted_69, 8, _hoisted_67))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["table-data", "table-header", "total"])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _createVNode(_component_TrainningInstituteModal)
  ], 64))
}